import { a as n, D as i, c, e as l, g as a, f as t, z as p, al as d, i as r } from "./define-element-XpjsV6s1.js";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const g = { class: "offset-prop65-warning" }, _ = ["aria-expanded", "aria-controls"], u = ["id"], v = {
  __name: "Prop65Warning",
  setup(m) {
    const e = n(!1), s = i();
    return (w, o) => (c(), l("div", g, [
      a("button", {
        type: "button",
        class: "offset-prop65-toggle",
        "aria-expanded": e.value,
        "aria-controls": t(s),
        onClick: o[0] || (o[0] = (h) => e.value = !e.value)
      }, " CALIFORNIA WARNING ", 8, _),
      p(a("p", {
        id: t(s),
        class: "offset-prop65-text"
      }, o[1] || (o[1] = [
        a("strong", null, "WARNING:", -1),
        r(" Drinking distilled spirits, beer, coolers, wine and other alcoholic beverages may increase cancer risk, and, during pregnancy, can cause birth defects. For more information go to ", -1),
        a("a", {
          href: "https://www.P65Warnings.ca.gov/alcohol",
          target: "_blank",
          rel: "noopener"
        }, "www.P65Warnings.ca.gov/alcohol", -1),
        r(". ", -1)
      ]), 8, u), [
        [d, e.value]
      ])
    ]));
  }
}, N = /* @__PURE__ */ f(v, [["__scopeId", "data-v-2726e306"]]);
export {
  N as P
};
